import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { TotpLoginRequest } from '../../../backend/model';
import { IDInputModule } from '@inera/ids-angular/components/form/input';
import { IDLinkModule } from '@inera/ids-angular/components/link';

@Component({
  selector: 'totp-authentication-form',
  imports: [IDInputModule, ReactiveFormsModule, IDLinkModule],
  templateUrl: './totp-authentication-form.component.html',
  styleUrl: './totp-authentication-form.component.css'
})
export class TotpAuthenticationFormComponent implements OnInit {
  private fb = inject(UntypedFormBuilder);

  public totpForm: UntypedFormGroup;

  @Output() loginRequest: EventEmitter<TotpLoginRequest> = new EventEmitter<TotpLoginRequest>();

  ngOnInit(): void {
    this.totpForm = this.fb.group({
      personId: '',
      code: ''
    });
  }

  public submitForm() {
    this.loginRequest.next(this.totpForm.value);
  }
}
